import { Formik, Form } from 'formik';
import { BiSave } from 'react-icons/bi';
import TranslatableText from '@components/translations/TranslatableText';
import GenericInputGroup from '@components/input/inputGroup/GenericInputGroup';
import ModuleButton from '@components/button/ModuleButton';
import { activityTitleField, endYearField, startYearField } from '@pages/project/activities/biodiversityActivityForm';
import { useEditBiodiversityActivity } from './hooks/useEditBiodiversityActivity';
import { type BiodiversityActivityFormValues } from '@pages/project/activities/biodiversityActivityForm';

interface EditBiodiversityActivityProps {
	setIsSuccessModalOpen: (isOpen: boolean) => void;
}

const EditBiodiversityActivity = ({ setIsSuccessModalOpen }: EditBiodiversityActivityProps) => {
	const {
		initialValues,
		validationSchema,
		handleSubmit,
		isUpdateLoading,
		updateErrorMessage,
		blockingError,
		isFetching,
	} = useEditBiodiversityActivity({ setIsSuccessModalOpen });

	if (blockingError) {
		return (
			<section>
				<div className="module-group ms-3">
					<div className="pos-relative mb-2 pb-1">
						<h2 className="fs-14 ff-medium-ext module-header w-fit">
							<TranslatableText translationKey="main.edit_activity" />
						</h2>
					</div>
					<span className="error fs-13 pb-2">{blockingError}</span>
				</div>
			</section>
		);
	}

	return (
		<section>
			<div className="module-group ms-3">
				<div className="pos-relative mb-2 pb-1">
					<h2 className="fs-14 ff-medium-ext module-header w-fit">
						<TranslatableText translationKey="main.edit_activity" />
					</h2>
				</div>

				<div className="d-flex f-column" style={{ maxWidth: '550px' }}>
					<Formik<BiodiversityActivityFormValues>
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={handleSubmit}
						enableReinitialize
					>
						{() => (
							<Form>
								<div className="d-flex f-column gap-3 pb-1">
									<div className="py-1">
										<GenericInputGroup
											inputGroup={{ ...activityTitleField, disabled: isFetching || isUpdateLoading }}
											showCommentIcon={false}
										/>
									</div>
									<div className="py-1">
										<GenericInputGroup
											inputGroup={{ ...startYearField, disabled: isFetching || isUpdateLoading }}
											showCommentIcon={false}
										/>
									</div>
									<div className="py-1">
										<GenericInputGroup
											inputGroup={{ ...endYearField, disabled: isFetching || isUpdateLoading }}
											showCommentIcon={false}
										/>
									</div>
								</div>

								{updateErrorMessage && (
									<p className="text-error fs-13 pb-2">{updateErrorMessage}</p>
								)}

								<div className="pb-2 d-flex align-items-center gap-8">
									<ModuleButton
										disabled={isUpdateLoading}
										isLoading={isUpdateLoading}
										icon={BiSave}
										labelKey="main.save_changes"
									/>
								</div>
							</Form>
						)}
					</Formik>
				</div>
			</div>
		</section>
	);
};

export default EditBiodiversityActivity;
